import React, { useState } from 'react';
import { Heart, Shield, FileText, HelpCircle, Users, Cookie, DollarSign, X, Tv, Info } from 'lucide-react';

export default function Footer({ onOpenPage }: { onOpenPage: (page: string) => void }) {
  const [showPixModal, setShowPixModal] = useState(false);
  const [copied, setCopied] = useState(false);

  const pixKey = "suportedoisplay@gmail.com"; 

  const handleCopyPix = () => {
    navigator.clipboard.writeText(pixKey);
    setCopied(true);
    setTimeout(() => setCopied(false), 3000);
  };

  return (
    <footer style={{
      backgroundColor: '#0a0a0a',
      color: '#888',
      padding: '50px 20px 30px 20px',
      borderTop: '1px solid #222',
      fontFamily: 'sans-serif',
      fontSize: '14px',
      // 🟢 AJUSTES PARA O RODAPÉ NÃO DESAPARECER
      width: '100%',
      marginTop: 'auto',
      position: 'relative',
      zIndex: 10,
      boxSizing: 'border-box'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '40px',
        marginBottom: '40px'
      }}>
        <div>
          <h3 style={{ color: '#fff', fontSize: '18px', fontWeight: 'bold', marginBottom: '15px' }}>Doisplay</h3>
          <p style={{ lineHeight: '1.6', fontSize: '13px', color: '#aaa' }}>
            Nossa missão é ser a sua vitrine favorita de filmes, games e vídeos curtos, sempre cheia de novidades! Trabalhamos para oferecer um entretenimento leve, divertido e seguro, valorizando o respeito a todos os criadores de conteúdo
          </p>
        </div>

        <div>
          <h4 style={{ color: '#fff', fontSize: '15px', fontWeight: 'bold', marginBottom: '15px' }}>Institucional</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <li>
              <button onClick={() => onOpenPage('quem-somos')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Users size={16} /> Quem Somos
              </button>
            </li>
            <li>
              <button onClick={() => onOpenPage('como-funciona')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Info size={16} /> Como Funciona
              </button>
            </li>
            <li>
              <button onClick={() => onOpenPage('termos')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <FileText size={16} /> Termos de Uso & Privacidade
              </button>
            </li>
            <li>
              <button onClick={() => onOpenPage('cookies')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Cookie size={16} /> Política de Cookies
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 style={{ color: '#fff', fontSize: '15px', fontWeight: 'bold', marginBottom: '15px' }}>Segurança & Suporte</h4>
          <ul style={{ listStyle: 'none', padding: 0, margin: 0, display: 'flex', flexDirection: 'column', gap: '10px' }}>
            <li>
              <button onClick={() => onOpenPage('denuncie')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <Shield size={16} /> Central de Denúncias
              </button>
            </li>
            <li>
              <button onClick={() => onOpenPage('suporte')} style={{ background: 'none', border: 'none', color: '#888', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                <HelpCircle size={16} /> Suporte
              </button>
            </li>
            <li>
              <button onClick={() => onOpenPage('canais-parceiros')} style={{ background: 'none', border: 'none', color: '#3b82f6', cursor: 'pointer', padding: 0, display: 'flex', alignItems: 'center', gap: '6px', fontWeight: 'bold' }}>
                <Tv size={16} /> Canais Parceiros
              </button>
            </li>
          </ul>
        </div>

        <div>
          <h4 style={{ color: '#fff', fontSize: '15px', fontWeight: 'bold', marginBottom: '15px' }}>Mantenha no Ar</h4>
          <p style={{ fontSize: '13px', color: '#aaa', marginBottom: '15px' }}>
            O Doisplay é mantido com carinho. Quer ajudar e fazer parte dessa comunidade? Qualquer valor via Pix é bem-vindo!
          </p>
          <button 
            onClick={() => setShowPixModal(true)}
            style={{
              backgroundColor: '#E50914', color: '#fff', border: 'none', padding: '10px 20px',
              borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px',
              transition: 'background 0.2s'
            }}
          >
            <DollarSign size={16} /> Apoie com Pix
          </button>
        </div>
      </div>

      <div style={{ textAlign: 'center', borderTop: '1px solid #1a1a1a', paddingTop: '20px', fontSize: '13px', color: '#666' }}>
        <p style={{ margin: '0 0 8px 0' }}>
          © {new Date().getFullYear()} Doisplay. Todos os direitos reservados. Versão Beta.
        </p>
        <p style={{ margin: 0, color: '#888' }}>
          Filmes, séries e trailers fornecidos em parceria com o{' '}
          <a 
            href="https://www.themoviedb.org" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{ color: '#3b82f6', textDecoration: 'none' }}
          >
            TMDB
          </a>.{' '}
          <span 
            onClick={() => onOpenPage('parceiro')} 
            style={{ color: '#aaa', textDecoration: 'underline', cursor: 'pointer', marginLeft: '4px' }}
          >
            Saiba mais sobre nossa fonte
          </span>
        </p>
      </div>

      {showPixModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.8)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center'
        }}>
          <div style={{
            backgroundColor: '#181818', padding: '30px', borderRadius: '8px', width: '90%', maxWidth: '400px',
            color: '#fff', position: 'relative', border: '1px solid #333', textAlign: 'center'
          }}>
            <button 
              onClick={() => setShowPixModal(false)}
              style={{ position: 'absolute', top: '15px', right: '15px', background: 'none', border: 'none', color: '#aaa', cursor: 'pointer' }}
            >
              <X size={20} />
            </button>

            <h3 style={{ marginBottom: '15px', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
              <Heart color="#E50914" fill="#E50914" size={20} /> Apoie o Doisplay
            </h3>
            <p style={{ fontSize: '13px', color: '#bbb', marginBottom: '20px', lineHeight: '1.5' }}>
              Sua doação ajuda a manter a plataforma no ar, investir em novas funções e deixar o design cada vez melhor. Estamos em versão Beta, então podem acontecer alguns bugs, mas estamos melhorando a cada dia! O valor vai direto para o criador.
            </p>

            <div style={{ backgroundColor: '#000', padding: '15px', borderRadius: '6px', marginBottom: '15px', wordBreak: 'break-all', fontSize: '13px', color: '#ddd', border: '1px solid #333' }}>
              {pixKey}
            </div>

            <button 
              onClick={handleCopyPix}
              style={{
                width: '100%', backgroundColor: copied ? '#22c55e' : '#E50914', color: '#fff', border: 'none',
                padding: '12px', borderRadius: '4px', fontWeight: 'bold', cursor: 'pointer', transition: 'background 0.3s'
              }}
            >
              {copied ? 'Chave Pix Copiada!' : 'Copiar Chave Pix'}
            </button>
          </div>
        </div>
      )}
    </footer>
  );
}